export const VIRTUAL_WIDTH = 360;
export const VIRTUAL_HEIGHT = 640;

export const PHYSICS_HZ = 60;
export const FIXED_DT = 1 / PHYSICS_HZ;
export const MAX_FRAME_DT = 0.25;

export const GRAVITY = 1400;
export const FLAP_IMPULSE = 420;
export const MAX_FALL_SPEED = 700;

export const SCROLL_SPEED = 130;
export const PIPE_SPACING = 180;
export const PIPE_GAP = 150;
export const PIPE_WIDTH = 60;

export const GROUND_HEIGHT = 80;

export const STORAGE_KEY = "lizard-flap:v1";
export const SETTINGS_KEY = "lizard-flap:settings:v1";
export const SHOP_CACHE_KEY = "lizard-flap:shop:v1";
export const CUSTOM_KEY = "lizard-flap:custom:v1";

export const SHAKE_TRAUMA_DECAY = 1.6;
export const HIT_STOP_SECONDS = 0.08;

export const DIFFICULTY_MIN_GAP = 110;
export const DIFFICULTY_RAMP_SCORES = 30;
// Ghost races ramp difficulty by elapsed time (shared across both clients) so
// the pipe stream stays identical regardless of each player's own score.
export const DIFFICULTY_RAMP_SECONDS = 75;

// Day/night cycle length in pipes: the phase flips every NIGHT_THRESHOLD pipes
// (day 0–9, night 10–19, day 20–29, …).
export const NIGHT_THRESHOLD = 10;

// Time-based day/night half-cycle for ghost races, where difficulty is driven by
// elapsed time (not score) so both clients agree. Derived from the score cadence
// (NIGHT_THRESHOLD pipes) via the score→seconds ramp mapping, so a race's day/night
// rhythm matches a solo run's. = 10 * 75/30 = 25s.
export const NIGHT_SECONDS = (NIGHT_THRESHOLD * DIFFICULTY_RAMP_SECONDS) / DIFFICULTY_RAMP_SCORES;
